import { Component } from '@angular/core';

@Component({
    selector: 'osc-default-tooltip',
    templateUrl: './default-tooltip.component.html',
    styleUrls: ['./default-tooltip.component.scss'],
})
export class DefaultTooltipComponent {}
